<section class="section1">
	<div class="container">
		<div class="row">
			<div class="col-xl-12 col-md-10 col-sm-11 col-11 mx-auto semi">
				<h1
					class="size90 textcolor2"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				>
					Terms and Conditions of Use
				</h1>
				<h1
					class="size90 textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				>
					Pixtar Branding Services LLC
				</h1>
				<div class="list py-4">
					<ul
						class="mb-2 p-0"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<li class="mb-2 size18 py-2 lufgaregular">
							<span class="lufgasemibold">Effective Date:</span> [01/12/2024].
						</li>
						<li class="mb-2 size18 py-2 lufgaregular">
							These <span class="lufgasemibold">Terms of Use</span> (the
							“Agreement”) constitute a legally binding agreement between
							<span class="lufgasemibold">Pixtar Branding Services LLC,</span> a
							limited liability company registered in Dubai, United Arab
							Emirates (“<span class="lufgasemibold">Pixtar”</span>), and you
							(“<span class="lufgasemibold">Client</span>”), whether personally
							or on behalf of an entity, with respect to access and use of
							Pixtar’s website https://pixtar.ae (the “<span
								class="lufgasemibold"
								>Website</span
							>”), including any related services, media forms, channels, mobile
							websites, or applications
						</li>
						<li class="mb-2 size18 py-2 lufgaregular">
							By accessing the Website, you agree to comply with these Terms. If
							you do not agree, you are prohibited from using the Website and
							must cease use immediately.
						</li>
					</ul>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>
				<div class="list2">
					<h3
						class="size53 textcolor1 medium mb30"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Intellectual Property Rights
					</h3>
					<p
						class="py-4 size18 lufgaregular"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Unless otherwise stated, the Website, including all its source code,
						functionality, designs, text, graphics, trademarks, service marks,
						and other intellectual property (collectively, “<span
							class="lufgasemibold"
							>Content</span
						>”), is owned or controlled by
						<span class="lufgasemibold">Pixtar Branding Services LLC</span> and
						is protected under UAE intellectual property laws.
					</p>
					<p
						class="py-4 size18"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<span class="lufgasemibold">Restrictions</span>
					</p>

					<ul
						class="mb-5"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<li class="mb-2 size18 lufgaregular">
							You May Not Reproduce, Distribute, Modify, Create Derivative
							Works, Publicly Display, Or Exploit Any Content Without Pixtar’s
							Prior Written Permission.
						</li>
						<li class="mb-2 size18 lufgaregular">
							All Rights Not Expressly Granted Remain Reserved By Pixtar.
						</li>
					</ul>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium mb30"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Ownership of Materials
					</h3>
					<p
						class="size18 lufgaregular"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Pixtar creates original materials (“<span class="lufgasemibold"
							>Projects</span
						>”) for its Clients. Upon full payment, the copyright for all
						Projects is transferred to the Client. However:
					</p>

					<div class="py-4">
						<ul
							class="mb-2 ul-cus-de"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<li class="mb-2 size18 lufgaregular">
								Pixtar Reserves The Right To Showcase Completed Projects On Its
								Portfolio Or Marketing Channels Unless Otherwise Restricted By A
								Signed
								<span class="lufgasemibold"
									>Non-Disclosure Agreement (Nda).</span
								>
							</li>
							<li class="mb-2 size18 lufgaregular">
								The Client Warrants That Any Material Provided To Pixtar For
								Inclusion In Projects Is Owned Or Legally Licensed By The
								Client.
							</li>
						</ul>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Use of Third-Party Resources
					</h3>

					<div class="py-4">
						<p
							class="pb-4 size18 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							If a Project incorporates third-party resources, such as
							<span class="lufgasemibold">fonts or stock assets</span> requiring
							a commercial license (“<span class="lufgasemibold"
								>Third-Party Resources</span
							>”), Pixtar will notify the Client. The Client assumes
							responsibility for acquiring the necessary licenses for legal use.
							Pixtar is not liable for unauthorized use of such resources by the
							Client.
						</p>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						User Representations
					</h3>

					<div class="py-4">
						<p
							class="size18"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<span class="lufgasemibold"
								>By using the Website, you affirm that:</span
							>
						</p>
						<ul
							class="py-4 mb-2 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<li class="mb-2 size18">
								Using The Website For Purposes Other Than Those Intended By
								Pixtar.
							</li>
							<li class="mb-2 size18">
								Accessing The Website Through Automated Or Non-Human Means
								(E.G., Bots, Spiders).
							</li>
							<li class="mb-2 size18">
								Interfering With The Security Or Functionality Of The Website.
							</li>
							<li class="mb-2 size18">Misleading Pixtar Or Other Users.</li>
							<li class="mb-2 size18">
								Using The Website To Compete With Pixtar Or For Any Unauthorized
								Commercial Purpose.
							</li>
							<li class="mb-2 size18">
								Uploading Viruses, Malware, Or Malicious Content.
							</li>
							<li class="mb-2 size18">
								Violating Applicable Local, Federal, Or International Laws.
							</li>
						</ul>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Client Feedback
					</h3>

					<div class="py-4">
						<p
							class="size18 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							Any feedback, suggestions, or ideas submitted by the Client
							(“<span class="lufgasemibold">Submissions</span>”) become the
							exclusive property of Pixtar. Pixtar reserves the right to use
							Submissions for any lawful purpose without compensation or
							acknowledgment to the Client, unless agreed otherwise.
						</p>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Management of Website
					</h3>
					<div class="py-4">
						<p
							class="mb-2 size18 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<span class="lufgasemibold">Pixtar reserves the right to:</span>
						</p>

						<ul
							class="mb-2 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<li class="mb-2 size18">
								Monitor The Website For Violations Of These Terms.
							</li>
							<li class="mb-2 size18">
								Restrict Or Deny Access To The Website At Its Sole Discretion
								Without Prior Notice.
							</li>
						</ul>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Privacy Policy
					</h3>
					<div class="py-4">
						<p
							class="size18 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							By using the Website, you consent to the collection, use, and
							sharing of information as detailed in Pixtar’s
							<span class="lufgasemibold">Privacy Policy</span>. The Privacy
							Policy is incorporated herein by reference.
						</p>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Refunds and Payments
					</h3>
					<div class="py-4">
						<p
							class="mb-2 size18"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<span class="lufgasemibold"
								>Refunds are assessed on a case-by-case basis:</span
							>
						</p>
						<ul
							class="mb-2 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<li class="mb-2 size18">
								Refunds During The First Month Are Subject To A
								<span class="lufgasemibold">25% Cancellation Fee.</span>
							</li>
							<li class="mb-2 size18">
								If A Refund Is Issued, Any Designs Or Materials Created During
								That Time Remain The Property Of Pixtar And Must Not Be Used By
								The Client.
							</li>
						</ul>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Modifications to Website
					</h3>
					<div class="py-4">
						<p
							class="pb-4 size18 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							Pixtar reserves the right to modify or discontinue the Website or
							its content at any time without liability to the Client.
						</p>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Limitation of Liability
					</h3>
					<div class="py-4">
						<p
							class="size18 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							The Website and services are provided “<span class="lufgasemibold"
								>as-is</span
							>” and “<span class="lufgasemibold">as-available.</span>” Pixtar
							disclaims all warranties, including implied warranties of
							merchantability and fitness for a particular purpose.
						</p>
						<p
							class="mb-2 size18 py-4"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<span class="lufgasemibold">Pixtar shall not be liable for:</span>
						</p>
						<ul
							class="mb-2 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<li class="mb-2 size18">Errors Or Inaccuracies In Content.</li>
							<li class="mb-2 size18">
								Losses Resulting From Interruptions In Service.
							</li>
							<li class="mb-2 size18">
								Unauthorized Access To Personal Information.
							</li>
							<li class="mb-2 size18">
								Any Indirect, Consequential, Or Punitive Damages.
							</li>
						</ul>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Governing Law
					</h3>
					<div
						class="py-4"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<p
							class="size18 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							These Terms are governed by the laws of the
							<span class="lufgasemibold">United Arab Emirates.</span> Any
							disputes shall be resolved exclusively in the courts of
							<span class="lufgasemibold">Dubai.</span>
						</p>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Indemnification
					</h3>
					<div class="py-4">
						<p
							class="mb-2 size18 lufgasemibold"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<span class="lufgasemibold"
								>The Client agrees to indemnify and hold harmless Pixtar, its
								affiliates, and employees from any claims, losses, or damages
								arising from:</span
							>
						</p>
						<ul
							class="mb-2 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<li class="mb-2 size18">Client’s Breach Of These Terms.</li>
							<li class="mb-2 size18">
								Client’s Misuse Of The Website Or Services.
							</li>
							<li class="mb-2 size18">
								Violation Of Intellectual Property Rights By The Client.
							</li>
						</ul>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Electronic Communications
					</h3>
					<div
						class="py-4"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<p
							class="size18 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							By using the Website, you consent to receive electronic
							communications from Pixtar. Electronic communications satisfy
							legal requirements for written communication.
						</p>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Showcasing Design Work
					</h3>
					<div
						class="py-4"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<p class="size18 lufgaregular">
							Pixtar reserves the right to display completed Projects on its
							portfolio, website, or social media unless otherwise restricted by
							an <span class="lufgasemibold">NDA</span> signed with the Client.
						</p>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Indemnification
					</h3>
					<div
						class="py-4"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						<ul
							class="mb-2 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<li class="mb-2 size18">
								These Terms Constitute The Entire Agreement Between Pixtar And
								The Client.
							</li>
							<li class="mb-2 size18">
								If Any Provision Of These Terms Is Deemed Unlawful Or
								Unenforceable, The Remaining Provisions Remain Valid.
							</li>
							<li class="mb-2 size18">
								Pixtar’s Failure To Enforce Any Right Or Provision Does Not
								Constitute A Waiver.
							</li>
						</ul>
					</div>
				</div>
				<div
					class="customborder textcolor1"
					data-aos="fade-up"
					data-aos-duration="2000"
					data-aos-delay="100"
				></div>

				<div class="list2">
					<h3
						class="size53 textcolor1 medium"
						data-aos="fade-up"
						data-aos-duration="2000"
						data-aos-delay="100"
					>
						Contact Information
					</h3>
					<div class="py-4">
						<p
							class="mb-2 size18 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							For inquiries or complaints, please contact
							<span class="lufgasemibold">Pixtar Branding Services LLC</span>
							at:
						</p>
						<ul
							class="mb-2 lufgaregular"
							data-aos="fade-up"
							data-aos-duration="2000"
							data-aos-delay="100"
						>
							<li class="mb-2 size18">
								<a href="mailto:hey@pixtar.ae"
									><span class="lufgasemibold">Email:</span>
									hey&#64;pixtar.ae</a
								>
							</li>
							<li class="mb-2 size18">
								<a href="https://www.pixtar.ae"
									><span class="lufgasemibold">Website:</span> www.pixtar.ae</a
								>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
